import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Foretag = lazy(() => import("@/pages/elavtal/Foretag"));

export const Route = createFileRoute("/elavtal/foretag")({
  head: () => seoHead("/elavtal/foretag"),
  component: () => <Foretag />,
});
